import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
  Grid,
} from "@mui/material";

import { get } from "src/utils/networkUtils";
import UsersSignupChart from "src/components/users/UsersSignupChart";
import UsersCountSummary from "src/components/users/UsersCountSummary";

export default function HomePage() {
  const [statsLoading, setStatsLoading] = useState(true);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    setStatsLoading(true);
    get(`/admin/app-users/stats`)
      .then((response) => {
        setStats(response?.data ?? null);
        setStatsLoading(false);
      })
      .catch((error) => {
        console.error("Error loading stats:", error);
        setStatsLoading(false);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title> Home </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h4" gutterBottom>
            Home
          </Typography>
        </Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              {statsLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 300,
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : stats ? (
                <UsersSignupChart
                  title="Signups per Day"
                  subheader=""
                  height={280}
                  chartLabels={(stats.usersByDate ?? []).map(
                    (date) => date.date
                  )}
                  chartData={[
                    {
                      name: "Signups",
                      type: "column",
                      fill: "solid",
                      data: (stats.usersByDate ?? []).map(
                        (date) => date.userCount
                      ),
                    },
                  ]}
                />
              ) : (
                <Box sx={{ p: 3, textAlign: "center" }}>
                  <Typography variant="body2" color="text.secondary">
                    Failed to load signup data
                  </Typography>
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, mb: 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <UsersCountSummary
                title="Total Users"
                total={stats?.usersCount ?? 0}
              />
            </Grid>
            <Grid item xs={2}>
              <UsersCountSummary
                title="This Month"
                total={stats?.newUsersThisMonthCount ?? 0}
                color="info"
              />
            </Grid>
            <Grid item xs={2}>
              <UsersCountSummary
                title="Last Month"
                total={stats?.newUsersLastMonthCount ?? 0}
                color="info"
              />
            </Grid>
            <Grid item xs={2}>
              <UsersCountSummary
                title="This Week"
                total={stats?.newUsersThisWeekCount ?? 0}
                color="info"
              />
            </Grid>
            <Grid item xs={2}>
              <UsersCountSummary
                title="Last Week"
                total={stats?.newUsersLastWeekCount ?? 0}
                color="info"
              />
            </Grid>
            <Grid item xs={2}>
              <UsersCountSummary
                title="Today"
                total={stats?.newUsersCount ?? 0}
                color="info"
              />
            </Grid>
            <Grid item xs={2}>
              <UsersCountSummary
                title="Yesterday"
                total={stats?.newUsersYesterdayCount ?? 0}
                color="info"
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}
